export default function formatTime(inputDate) {
  if (!inputDate) return "";
  const date = new Date(inputDate);

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${hours}:${minutes}`; // for <input type="time">
}
